module.exports = __webpack_public_path__ + "img/default-product.b51a7162.jpg";